import styled from 'styled-components';

export const Columns = styled.div`
  flex-wrap: wrap;
  margin-left: -0.75rem;
  margin-right: -0.75rem;
  margin-top: -0.75rem;

  @media (min-width: 769px) {
    display: flex;
  }
`;

export const Column = styled.div`
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 0.75rem;

  @media (min-width: 769px) {
    flex: none;
    width: 50%;
  }

  @media (min-width: 1088px) {
    flex: none;
    width: 25%;
  }
`;

export const Container = styled.div`
  margin: 0 auto;
  position: relative;

  @media (min-width: 1088px){
    max-width: 960px;
    width: 960px;
  }

  @media (min-width: 1280px){
    max-width: 1152px;
    width: 1152px;
  }

  @media screen and (min-width: 1472px){
    max-width: 1344px;
    width: 1344px;
  }
`;


export const Section = styled.section`
  padding: 1.5rem;
`;